import { ContentBlock, ContentBlockType } from '@tytapp/content';
import { Component } from '@angular/core';
import { ContentBlockEditorComponent } from '@tytapp/content/content-block-editor-component';
import { ContentBlockViewComponent } from '@tytapp/content/content-block-view-component';

export interface SectionTagBlock extends ContentBlock {
    text: string;
}

@Component({
    template: `
        {{block.text}}
    `,
    styles: [
        `
        :host {
            display: block;
            width: fit-content;
            background-color: #393d4d;
            color: white;
            font-size: 80%;
            padding: 0.5em 1.5em;
        }
        `
    ]
})
export class ViewComponent extends ContentBlockViewComponent<SectionTagBlock> {
}

@Component({
    template: `
        <mat-form-field>
            <mat-label>Section Tag</mat-label>
            <input name="text" matInput type="text" [(ngModel)]="block.text" [disabled]="locked" />
        </mat-form-field>
    `,
    styles: [
        `
        mat-form-field {
            width: 100%;
        }
        `
    ]
})
export class EditorComponent extends ContentBlockEditorComponent<SectionTagBlock> {
}

export const SECTION_TAG_BLOCK_TYPE: ContentBlockType<SectionTagBlock> = {
    id: 'section-tag',
    label: 'Section Tag',
    icon: 'label',
    template: {
       text: 'Section Tag'
    },
    preview: {
        text: 'The quick brown fox jumps over the lazy dog'
    },
    previewSettings: {
        horizontalAlign: 'center',
        verticalAlign: 'center'
    },
    editorComponent: EditorComponent,
    viewComponent: ViewComponent
};